import React from 'react';

function Icon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="234" height="333" version="1.1">
            <g transform="translate(0 -719.362)">
                <g fillOpacity="1">
                    <rect
                        width="233.244"
                        height="332.244"
                        x="0.378"
                        y="719.74"
                        fill="#fff"
                        stroke="gray"
                        strokeDasharray="none"
                        strokeLinecap="butt"
                        strokeLinejoin="miter"
                        strokeMiterlimit="4"
                        strokeOpacity="1"
                        strokeWidth="0.756"
                        rx="8.919"
                        ry="8.946"
                    ></rect>
                    <g
                        fill="#000"
                        stroke="none"
                        strokeWidth="3.181"
                        transform="matrix(.05649 0 0 .05667 -79.73 833.66)"
                    >
                        <path d="M2406.706 536.549H2491.962V832.2339999999999H2406.706z"></path>
                        <path d="M2917.856 395.129c67.135 120.804 23.601 273.145-97.235 340.262-120.836 67.117-273.216 23.594-340.35-97.21-17.88-32.173-28.44-67.893-30.889-104.572-9.342 137.92-128.747 242.091-266.662 232.714-137.914-9.378-242.11-128.753-232.73-266.631 9.38-137.878 128.785-242.049 266.7-232.671 36.205 2.462 71.442 12.765 103.724 30.221-118.192-70.885-156.875-224.529-85.945-343.145 70.93-118.617 224.613-157.29 343.261-86.379 118.647 70.912 157.33 224.555 86.4 343.172-21.34 35.69-51.243 65.5-86.812 86.882 121.024-66.97 273.404-23.448 340.538 97.357z"></path>
                    </g>
                    <g
                        style={{ lineHeight: '0%' }}
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="3.772"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        transform="scale(.72185 1.38533)"
                        wordSpacing="0"
                    >
                        <path
                            style={{ lineHeight: '1.25' }}
                            strokeWidth="1"
                            d="M23.835 544.63q0 .354-.127.623-.34.113-.735.113h-10.44q-.934 0-.934-.99 0-.17.029-.538.028-.382.028-.58 0-.933.82-.933H16v-13.071h-4.3q-.906 0-.906-.99 0-.212.043-.68.056-.48.056-.72 0-.482.905-.482.255 0 .962.057.708.042 1.104.042 2.263 0 2.744-1.57h2.702v17.414q.948 0 2.037-.057 1.103-.07 1.315-.07.82 0 1.019.438.155.382.155 1.994z"
                            fontSize="28.97"
                        ></path>
                    </g>
                    <g
                        style={{ lineHeight: '0%' }}
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="3.772"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        transform="scale(.69919 1.43023)"
                        wordSpacing="0"
                    >
                        <path
                            style={{ lineHeight: '1.25' }}
                            strokeWidth="1"
                            d="M38.073 518.577q0 9.67-6.685 9.67-6.78 0-6.78-9.724 0-10.089 6.915-10.089 6.55 0 6.55 10.143zm-3.512-.284q0-6.928-3.227-6.928-1.891 0-2.688 2.741-.5 1.73-.5 4.309 0 6.928 3.188 6.928 1.904 0 2.714-2.728.513-1.756.513-4.322z"
                            fontSize="27.659"
                        ></path>
                    </g>
                    <g
                        fill="#000"
                        stroke="none"
                        strokeWidth="3.181"
                        transform="matrix(.01883 0 0 .0189 -28.915 764.98)"
                    >
                        <path d="M2406.706 536.549H2491.962V832.2339999999999H2406.706z"></path>
                        <path d="M2917.856 395.129c67.135 120.804 23.601 273.145-97.235 340.262-120.836 67.117-273.216 23.594-340.35-97.21-17.88-32.173-28.44-67.893-30.889-104.572-9.342 137.92-128.747 242.091-266.662 232.714-137.914-9.378-242.11-128.753-232.73-266.631 9.38-137.878 128.785-242.049 266.7-232.671 36.205 2.462 71.442 12.765 103.724 30.221-118.192-70.885-156.875-224.529-85.945-343.145 70.93-118.617 224.613-157.29 343.261-86.379 118.647 70.912 157.33 224.555 86.4 343.172-21.34 35.69-51.243 65.5-86.812 86.882 121.024-66.97 273.404-23.448 340.538 97.357z"></path>
                    </g>
                    <g
                        style={{ lineHeight: '0%' }}
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="3.772"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        transform="scale(-.72185 -1.38533)"
                        wordSpacing="0"
                    >
                        <path
                            style={{ lineHeight: '1.25' }}
                            strokeWidth="1"
                            d="M-300.333-734.284q0 .353-.127.622-.34.113-.736.113h-10.44q-.933 0-.933-.99 0-.17.029-.538.028-.381.028-.58 0-.933.82-.933h3.523v-13.07h-4.3q-.906 0-.906-.991 0-.212.042-.679.057-.48.057-.721 0-.481.905-.481.255 0 .962.056.707.043 1.104.043 2.263 0 2.744-1.57h2.702v17.413q.947 0 2.037-.057 1.103-.07 1.315-.07.82 0 1.019.438.155.382.155 1.995z"
                            fontSize="28.97"
                        ></path>
                    </g>
                    <g
                        style={{ lineHeight: '0%' }}
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="3.772"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        transform="scale(-.69919 -1.43023)"
                        wordSpacing="0"
                    >
                        <path
                            style={{ lineHeight: '1.25' }}
                            strokeWidth="1"
                            d="M-296.6-720.192q0 9.67-6.686 9.67-6.78 0-6.78-9.724 0-10.089 6.915-10.089 6.55 0 6.55 10.143zm-3.512-.284q0-6.928-3.228-6.928-1.89 0-2.688 2.741-.5 1.729-.5 4.309 0 6.928 3.188 6.928 1.904 0 2.715-2.728.513-1.756.513-4.322z"
                            fontSize="27.659"
                        ></path>
                    </g>
                    <g
                        fill="#000"
                        stroke="none"
                        strokeWidth="3.181"
                        transform="matrix(.01883 0 0 -.0189 170.674 1006.744)"
                    >
                        <path d="M2406.706 536.549H2491.962V832.2339999999999H2406.706z"></path>
                        <path d="M2917.856 395.129c67.135 120.804 23.601 273.145-97.235 340.262-120.836 67.117-273.216 23.594-340.35-97.21-17.88-32.173-28.44-67.893-30.889-104.572-9.342 137.92-128.747 242.091-266.662 232.714-137.914-9.378-242.11-128.753-232.73-266.631 9.38-137.878 128.785-242.049 266.7-232.671 36.205 2.462 71.442 12.765 103.724 30.221-118.192-70.885-156.875-224.529-85.945-343.145 70.93-118.617 224.613-157.29 343.261-86.379 118.647 70.912 157.33 224.555 86.4 343.172-21.34 35.69-51.243 65.5-86.812 86.882 121.024-66.97 273.404-23.448 340.538 97.357z"></path>
                    </g>
                    <g
                        fill="#000"
                        stroke="none"
                        strokeWidth="3.181"
                        transform="matrix(.05649 0 0 -.05667 -79.73 1004.813)"
                    >
                        <path d="M2406.706 536.549H2491.962V832.2339999999999H2406.706z"></path>
                        <path d="M2917.856 395.129c67.135 120.804 23.601 273.145-97.235 340.262-120.836 67.117-273.216 23.594-340.35-97.21-17.88-32.173-28.44-67.893-30.889-104.572-9.342 137.92-128.747 242.091-266.662 232.714-137.914-9.378-242.11-128.753-232.73-266.631 9.38-137.878 128.785-242.049 266.7-232.671 36.205 2.462 71.442 12.765 103.724 30.221-118.192-70.885-156.875-224.529-85.945-343.145 70.93-118.617 224.613-157.29 343.261-86.379 118.647 70.912 157.33 224.555 86.4 343.172-21.34 35.69-51.243 65.5-86.812 86.882 121.024-66.97 273.404-23.448 340.538 97.357z"></path>
                    </g>
                    <g
                        fill="#000"
                        stroke="none"
                        strokeWidth="3.181"
                        transform="matrix(.05649 0 0 .05667 -79.73 766.911)"
                    >
                        <path d="M2406.706 536.549H2491.962V832.2339999999999H2406.706z"></path>
                        <path d="M2917.856 395.129c67.135 120.804 23.601 273.145-97.235 340.262-120.836 67.117-273.216 23.594-340.35-97.21-17.88-32.173-28.44-67.893-30.889-104.572-9.342 137.92-128.747 242.091-266.662 232.714-137.914-9.378-242.11-128.753-232.73-266.631 9.38-137.878 128.785-242.049 266.7-232.671 36.205 2.462 71.442 12.765 103.724 30.221-118.192-70.885-156.875-224.529-85.945-343.145 70.93-118.617 224.613-157.29 343.261-86.379 118.647 70.912 157.33 224.555 86.4 343.172-21.34 35.69-51.243 65.5-86.812 86.882 121.024-66.97 273.404-23.448 340.538 97.357z"></path>
                    </g>
                    <g
                        fill="#000"
                        stroke="none"
                        strokeWidth="3.181"
                        transform="matrix(.05649 0 0 .05667 -21.36 800.285)"
                    >
                        <path d="M2406.706 536.549H2491.962V832.2339999999999H2406.706z"></path>
                        <path d="M2917.856 395.129c67.135 120.804 23.601 273.145-97.235 340.262-120.836 67.117-273.216 23.594-340.35-97.21-17.88-32.173-28.44-67.893-30.889-104.572-9.342 137.92-128.747 242.091-266.662 232.714-137.914-9.378-242.11-128.753-232.73-266.631 9.38-137.878 128.785-242.049 266.7-232.671 36.205 2.462 71.442 12.765 103.724 30.221-118.192-70.885-156.875-224.529-85.945-343.145 70.93-118.617 224.613-157.29 343.261-86.379 118.647 70.912 157.33 224.555 86.4 343.172-21.34 35.69-51.243 65.5-86.812 86.882 121.024-66.97 273.404-23.448 340.538 97.357z"></path>
                    </g>
                    <g
                        fill="#000"
                        stroke="none"
                        strokeWidth="3.181"
                        transform="matrix(.05649 0 0 .05667 37.01 766.911)"
                    >
                        <path d="M2406.706 536.549H2491.962V832.2339999999999H2406.706z"></path>
                        <path d="M2917.856 395.129c67.135 120.804 23.601 273.145-97.235 340.262-120.836 67.117-273.216 23.594-340.35-97.21-17.88-32.173-28.44-67.893-30.889-104.572-9.342 137.92-128.747 242.091-266.662 232.714-137.914-9.378-242.11-128.753-232.73-266.631 9.38-137.878 128.785-242.049 266.7-232.671 36.205 2.462 71.442 12.765 103.724 30.221-118.192-70.885-156.875-224.529-85.945-343.145 70.93-118.617 224.613-157.29 343.261-86.379 118.647 70.912 157.33 224.555 86.4 343.172-21.34 35.69-51.243 65.5-86.812 86.882 121.024-66.97 273.404-23.448 340.538 97.357z"></path>
                    </g>
                    <g fill="#000" stroke="none" strokeWidth="3.181" transform="matrix(.05649 0 0 .05667 37.01 833.66)">
                        <path d="M2406.706 536.549H2491.962V832.2339999999999H2406.706z"></path>
                        <path d="M2917.856 395.129c67.135 120.804 23.601 273.145-97.235 340.262-120.836 67.117-273.216 23.594-340.35-97.21-17.88-32.173-28.44-67.893-30.889-104.572-9.342 137.92-128.747 242.091-266.662 232.714-137.914-9.378-242.11-128.753-232.73-266.631 9.38-137.878 128.785-242.049 266.7-232.671 36.205 2.462 71.442 12.765 103.724 30.221-118.192-70.885-156.875-224.529-85.945-343.145 70.93-118.617 224.613-157.29 343.261-86.379 118.647 70.912 157.33 224.555 86.4 343.172-21.34 35.69-51.243 65.5-86.812 86.882 121.024-66.97 273.404-23.448 340.538 97.357z"></path>
                    </g>
                    <g
                        fill="#000"
                        stroke="none"
                        strokeWidth="3.181"
                        transform="matrix(.05649 0 0 -.05667 -79.73 938.065)"
                    >
                        <path d="M2406.706 536.549H2491.962V832.2339999999999H2406.706z"></path>
                        <path d="M2917.856 395.129c67.135 120.804 23.601 273.145-97.235 340.262-120.836 67.117-273.216 23.594-340.35-97.21-17.88-32.173-28.44-67.893-30.889-104.572-9.342 137.92-128.747 242.091-266.662 232.714-137.914-9.378-242.11-128.753-232.73-266.631 9.38-137.878 128.785-242.049 266.7-232.671 36.205 2.462 71.442 12.765 103.724 30.221-118.192-70.885-156.875-224.529-85.945-343.145 70.93-118.617 224.613-157.29 343.261-86.379 118.647 70.912 157.33 224.555 86.4 343.172-21.34 35.69-51.243 65.5-86.812 86.882 121.024-66.97 273.404-23.448 340.538 97.357z"></path>
                    </g>
                    <g
                        fill="#000"
                        stroke="none"
                        strokeWidth="3.181"
                        transform="matrix(.05649 0 0 -.05667 -21.36 971.439)"
                    >
                        <path d="M2406.706 536.549H2491.962V832.2339999999999H2406.706z"></path>
                        <path d="M2917.856 395.129c67.135 120.804 23.601 273.145-97.235 340.262-120.836 67.117-273.216 23.594-340.35-97.21-17.88-32.173-28.44-67.893-30.889-104.572-9.342 137.92-128.747 242.091-266.662 232.714-137.914-9.378-242.11-128.753-232.73-266.631 9.38-137.878 128.785-242.049 266.7-232.671 36.205 2.462 71.442 12.765 103.724 30.221-118.192-70.885-156.875-224.529-85.945-343.145 70.93-118.617 224.613-157.29 343.261-86.379 118.647 70.912 157.33 224.555 86.4 343.172-21.34 35.69-51.243 65.5-86.812 86.882 121.024-66.97 273.404-23.448 340.538 97.357z"></path>
                    </g>
                    <g
                        fill="#000"
                        stroke="none"
                        strokeWidth="3.181"
                        transform="matrix(.05649 0 0 -.05667 37.01 1004.813)"
                    >
                        <path d="M2406.706 536.549H2491.962V832.2339999999999H2406.706z"></path>
                        <path d="M2917.856 395.129c67.135 120.804 23.601 273.145-97.235 340.262-120.836 67.117-273.216 23.594-340.35-97.21-17.88-32.173-28.44-67.893-30.889-104.572-9.342 137.92-128.747 242.091-266.662 232.714-137.914-9.378-242.11-128.753-232.73-266.631 9.38-137.878 128.785-242.049 266.7-232.671 36.205 2.462 71.442 12.765 103.724 30.221-118.192-70.885-156.875-224.529-85.945-343.145 70.93-118.617 224.613-157.29 343.261-86.379 118.647 70.912 157.33 224.555 86.4 343.172-21.34 35.69-51.243 65.5-86.812 86.882 121.024-66.97 273.404-23.448 340.538 97.357z"></path>
                    </g>
                    <g
                        fill="#000"
                        stroke="none"
                        strokeWidth="3.181"
                        transform="matrix(.05649 0 0 -.05667 37.01 938.065)"
                    >
                        <path d="M2406.706 536.549H2491.962V832.2339999999999H2406.706z"></path>
                        <path d="M2917.856 395.129c67.135 120.804 23.601 273.145-97.235 340.262-120.836 67.117-273.216 23.594-340.35-97.21-17.88-32.173-28.44-67.893-30.889-104.572-9.342 137.92-128.747 242.091-266.662 232.714-137.914-9.378-242.11-128.753-232.73-266.631 9.38-137.878 128.785-242.049 266.7-232.671 36.205 2.462 71.442 12.765 103.724 30.221-118.192-70.885-156.875-224.529-85.945-343.145 70.93-118.617 224.613-157.29 343.261-86.379 118.647 70.912 157.33 224.555 86.4 343.172-21.34 35.69-51.243 65.5-86.812 86.882 121.024-66.97 273.404-23.448 340.538 97.357z"></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default Icon;
